import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { ImpactAgentFeedbackStatus } from "gql/apollo/graphql";
import { useCallback } from "react";
import useSnackbar from "utils/useSnackbar";

import { CountImpactAgentFeedbacks } from "../queries/useCountImpactAgentFeedbacks";
import { ListImpactAgentFeedbacks } from "../queries/useListImpactAgentFeedbacks";

export const UpdateImpactAgentFeedback = graphql(/* GraphQL */ `
	mutation UpdateImpactAgentFeedback(
		$params: UpdateImpactAgentFeedbackParams!
	) {
		updateImpactAgentFeedback(params: $params) {
			success
			error {
				code
				message
			}
		}
	}
`);

export const impactAgentFeedbackRefetchQueries = [
	ListImpactAgentFeedbacks,
	CountImpactAgentFeedbacks,
];

export function useUpdateImpactAgentFeedback() {
	const { handleError } = useSnackbar();
	const [updateImpactAgentFeedback, { loading }] = useMutation(
		UpdateImpactAgentFeedback,
		{
			refetchQueries: impactAgentFeedbackRefetchQueries,
			awaitRefetchQueries: true,
		}
	);

	const updateFeedbackStatus = useCallback(
		async (_id: string, feedbackStatus: ImpactAgentFeedbackStatus) => {
			try {
				const result = await updateImpactAgentFeedback({
					variables: { params: { _id, feedback_status: feedbackStatus } },
				});

				const response = result.data?.updateImpactAgentFeedback;

				if (response?.error) {
					handleError(response.error);
					return false;
				}

				return !!response?.success;
			} catch (error) {
				handleError(error);
				return false;
			}
		},
		[updateImpactAgentFeedback, handleError]
	);

	return { updateFeedbackStatus, loading };
}
